import type { Component } from 'vue'
import { defineNuxtPlugin } from '#app'

const toKebabCase = (value: string) =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/_/g, '-')
    .toLowerCase()

const toLooseCase = (value: string) =>
  toKebabCase(value).replace(/-/g, '')

const modules = import.meta.glob(
  [
    '~/components/**/*.vue',
    '!~/components/TemplateNodeRenderer.vue',
    '!~/components/TemplateRenderer.vue',
    '!~/components/renderer/**',
  ],
  { eager: true },
)

export default defineNuxtPlugin((nuxtApp) => {
  Object.entries(modules).forEach(([path, mod]) => {
    const fileName = path.split('/').pop() || ''
    const baseName = fileName.replace(/\.vue$/i, '')
    if (!baseName) return

    const component = (mod as { default?: Component }).default || (mod as Component)
    if (!component) return

    const aliases = new Set([baseName, toKebabCase(baseName), toLooseCase(baseName)])

    aliases.forEach((name) => {
      if (!name) return
      if (nuxtApp.vueApp.component(name)) return
      nuxtApp.vueApp.component(name, component)
    })
  })
})
